import AdminOrganizations from './AdminOrganizations'
export default AdminOrganizations
